import React, { use, useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Form,
    Modal,
    ModalBody,
    Input,
    FormGroup,
    ModalHeader,
    Button,
    Label,
    FormFeedback,
    Row,
    Col,
} from "reactstrap"
import * as Yup from "yup"

import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Select from "react-select";
import { dateFormat } from "pages/Common"
import DeleteModel from "common/deleteModel/deleteModel"
import ErrorModel from "common/errorModel/errorModel"
import { exportDataExcel } from "components/Common/ExportData"
import uploadImage from "../../assets/images/no_image.jpg"
import CreateUpdateKhaKhaRackModel from "./CreateUpdateKha_KhaRackModel"
import Kha_KhaRackTable from "./Kha_KhaRackTable"

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

function Kha_KhaRackList() {
    document.title = `Rack Shelf Data | Raja Rani Couture`
    let { pathname } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()

    const navigate = useNavigate()

    // useStates
    const [modal, setModal] = useState(false)
    const [modal1, setModal1] = useState(false)
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [statusValue, setStatusValue] = useState(0)
    const [isEdit, setIsEdit] = useState(false)
    const [editData, setEditData] = useState()
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    const [image, setImage] = useState('')
    const [imageViewModal, setImageViewModal] = useState(false)
    // filter data for task-title
    const filterData = textFilter => {
        setSearchText(textFilter == undefined ? '' : textFilter)
    }
    const [userFilter, setUserFilter] = useState(0)
    const [rackShelfFilter, setRackShelfFilter] = useState(0)
    const [rackShelf, setRackShelf] = useState([])
    const [users, setUsers] = useState([])
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(true)

    useEffect(() => {
        getApi('RackShelf/lookup').then(({ data, status }) => {
            if (status === 200) {
                setRackShelf(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // task-title list api
    const rackShelfDataListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("Rackshelf/data/list", {
            userId: parseInt(userFilter),
            rackshelfId: parseInt(rackShelfFilter),
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
            IsMaterial: false,
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data?.RackshelfDataList)
                setTotalRecords(data?.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // task-title list api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined) {
            rackShelfDataListApi()
        }
    }, [searchText, displayStart, rowsPerPage, userFilter, rackShelfFilter])


    // Create task-title handler
    const handleRackShelfDataClick = () => {
        toggle()
        setIsEdit(false)
        setEditData()
    }

    // popup box handler
    const toggle = () => {
        setModal(!modal)
        // validation.handleReset()
    }

    const handleEdit = (data) => {
        setEditData(data)
        setIsEdit(true)
        toggle()
    }

    const handleDelete = (Id) => {
        setIsLoading(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this kha-kha rack permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Rackshelf/data/delete?id=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Making deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Making",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }

    }

    const handleImageView = (Image) => {
        setImage(Image)
        imageViewToggle()
    }

    const imageViewToggle = () => {
        setImageViewModal(!imageViewModal)
    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Image",
                accessor: "Image",
                width: "5%",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div>
                                <img
                                    onClick={() => handleImageView(row.original.Image)}
                                    style={{
                                        cursor: "pointer",
                                        border: "1px solid #ced4da",
                                        borderRadius: "3px",
                                    }}
                                    width="50px"
                                    height="60px"
                                    src={row.original?.Image || uploadImage}
                                />
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Main Rack No.",
                accessor: "RackshelfByName",
                width: "14%",
            },
            {
                Header: "Sub Rack No.",
                accessor: "Name",
                width: "14%",
            },
            {
                Header: "Decscription",
                accessor: "Description",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{ textWrap: "wrap" }}>
                                {row.original.Description ? row.original.Description : "N/A"}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Created By",
                accessor: "CreatedByName",
                width: "10%"
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "10%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.CreatedOn == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.CreatedOn.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                // Header: () => (
                //     <div
                //         style={{
                //             textAlign: "center",
                //         }}
                //     >
                //         Action
                //     </div>
                // ),
                Header: "Action",
                width: "5%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleEdit(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>

                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDelete(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )

    function writeDataToExcel() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Main Rack No.", "Sub Rack No.", "Decscription", "Created By", "Created On"];
            const mainTitle = "Kha-Kha Reack";
            const widthObj = [{
                Key: "A",
                Value: 18,
            },
            {
                Key: "B",
                Value: 18,
            },
            {
                Key: "C",
                Value: 25,
            },
            {
                Key: "D",
                Value: 18,
            },
            {
                Key: "E",
                Value: 18,
            },
            {
                Key: "F",
                Value: 18,
            },
            ]
            const extention = "Kha_Kha_Rack.xlsx"
            let excelSheetData = []

            postApi("Rackshelf/data/list", {
                userId: parseInt(userFilter),
                rackshelfId: parseInt(rackShelfFilter),
                displayStart: displayStart,
                pageSize: rowsPerPage,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
                IsMaterial: false,
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.RackshelfDataList.length; index++) {
                        let dataObj = {
                            mainShelfName: data?.RackshelfDataList[index].RackshelfByName,
                            Name: data?.RackshelfDataList[index].Name,
                            Decscription: data?.RackshelfDataList[index].Decscription ? data?.RackshelfDataList[index].Decscription : "N/A",
                            CreatedByName: data?.RackshelfDataList[index].CreatedByName,
                            CreatedOn: data?.RackshelfDataList[index].CreatedOn == null
                                ? "N/A"
                                : dateFormat(data?.RackshelfDataList[index].CreatedOn, "dd-MM-yyyy"),
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })

            setIsLoading(false)
        }
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <Kha_KhaRackTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isAddRackShelfDataList={true}
                            handleRackShelfDataClick={handleRackShelfDataClick}
                            customPageSize={10}
                            className="custom-header-css"
                            filterData={filterData}
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            setDateFilter={setDateFilter}
                            dateFilter={dateFilter}
                            rackShelf={rackShelf}
                            userFilter={userFilter}
                            setUserFilter={setUserFilter}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            writeDataToExcel={writeDataToExcel}
                            users={users}
                            rackShelfFilter={rackShelfFilter}
                            setRackShelfFilter={setRackShelfFilter}
                        />

                        <CreateUpdateKhaKhaRackModel
                            modal={modal}
                            toggle={toggle}
                            rackShelfDataListApi={rackShelfDataListApi}
                            isEdit={isEdit}
                            editData={editData}
                            rackShelf={rackShelf}
                        />

                        <Modal
                            isOpen={imageViewModal}
                            toggle={imageViewToggle}
                            centered={true}
                            size="defult"
                            style={{ width: isMobile ? "" : "500" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={imageViewToggle} tag="h5">
                                    Image
                                </ModalHeader>
                                <ModalBody>
                                    <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                                        <img
                                            style={{
                                                cursor: "pointer",
                                                border: "1px solid #ced4da",
                                                borderRadius: "3px",
                                            }}
                                            width="400px"
                                            height="450px"
                                            src={image || uploadImage}
                                        />
                                    </div>
                                </ModalBody>
                            </div>
                        </Modal>

                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
Kha_KhaRackList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default Kha_KhaRackList
